module.exports = __webpack_public_path__ + "img/gcbm-import-all-folder-structure.fe5bb9dd.png";